/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { Modal } from 'antd-mobile'
import * as _ from 'lodash'

// css
import { Button, CloseBtn } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { ModalBg } from '@styles/base.style'
import { TipDetailWrap } from './index.style'

const TipDetailPopup: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleTipDetail } = globalStore
  const { tipDetail } = componentStore

  const doCloseTipDetail = () => {
    componentStore.setTipDetail(null)
    globalStore.setVisibleTipDetail(false)
  }

  const renderTipDetailImg = (
    <div dangerouslySetInnerHTML={{__html: tipDetail?.content}}/>
  )

  return (
    <Modal
      popup
      maskClosable={false}
      visible={visibleTipDetail}
      animated={isMobile}
      animationType="slide-up"
      title={
        <Fragment>
          <h1 className="title">상세 내용</h1>
          <Button onClick={doCloseTipDetail} className="close-btn" css={CloseBtn}>
            <span className="close-txt">닫기</span>
          </Button>
        </Fragment>
      }
      className="full-modal"
      onClose={doCloseTipDetail}
    >
      <TipDetailWrap>
        {!_.isEmpty(tipDetail?.content) && renderTipDetailImg}
      </TipDetailWrap>

      <ModalBg/>
    </Modal>
  )
}
export default observer(TipDetailPopup)
